import React from "react";
import { Routes, Route } from "react-router-dom";
import WelcomeExperience from "./containers/WelcomeExperience";
import SessionOut from "./containers/WelcomeExperience/ErrorContainer/ConnectionOut";
import NotFound from "../Common/components/NotFound/NotFound";
import Error from "../Common/components/Error/Error";

const App = () => {
  return (
    <Routes>
      <Route path="/" element={<WelcomeExperience />} />
      <Route exact path="/sessiontimeout" element={<SessionOut />} />
      <Route path="/error" element={<Error />} />
      <Route path="/notfound" element={<NotFound />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default App;
